import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { InventoryService } from '../../../inventory/inventory.service';
import { PrintingService } from '../../../../shared/services/printing.service';
import { Piece } from '../../../inventory/piece';
import { Product } from '../../../purchasing/products/product';
import { ProductService } from '../../../purchasing/products/product.service';

@Component({
  selector: 'app-cut-item',
  templateUrl: './cut-item.component.html',
  styleUrls: ['./cut-item.component.scss'],
  providers: [PrintingService]
})
export class InvCutItemComponent implements OnInit {
  pieceNumber: string;

  newPieceNumber: string;

  fullLength: number;
  newLength: number;

  pieceExists: boolean = false;

  constructor(private _dialogService: TdDialogService,
    private location: Location,
    public _authService: AuthenticationService,
    private _inventoryService: InventoryService,
    private _printingService: PrintingService,
    private _productService: ProductService
  ) { }

  ngOnInit(): void {
  }

  goBack(): void {
    this.location.back();
  }

  findItem(pieceNumber: string): void {
    this._inventoryService.findByPieceNumber(pieceNumber).subscribe(
      response => {
        // Clean previous values
        this.fullLength = null;
        this.newPieceNumber = null;
        this.pieceExists = false;

        if (response.length) {
          this.fullLength = response['length'];
          this.pieceExists = true;

          //Suggest new piece number 
          this._inventoryService.suggestNextNumber(pieceNumber).subscribe(
            response => {
              this.newPieceNumber = response.number;
            }
          );

          //this.newPieceNumber = this.generateNewPieceNumber(pieceNumber);
        } else {
          this._dialogService.openAlert({ title: 'PROBLEM', message: 'The piece you entered does not exist, or it has been sold' });
        }
      }
    );
  }

  generateNewPieceNumber(old_number: string): string {
    let last_char = old_number.charCodeAt(old_number.length - 1);
    let newPieceNumber = '';

    if (last_char >= 65 && last_char <= 90) {
      // It's a letter, it's been cut before. 
      newPieceNumber = old_number.substr(0, old_number.length - 1) + String.fromCharCode(last_char + 1);
    } else {
      // Otherwise just append an A
      newPieceNumber = old_number + 'A';
    }

    return newPieceNumber + '';
  }

  cutItem(): void {
    if (!this.pieceExists) {
      this._dialogService.openAlert({
        message: 'Please verify that the piece you are trying to cut exists by clicking "Find"',
        title: 'Verify your data'
      });
      return;
    }

    if (!this.newLength) {
      this._dialogService.openAlert({
        message: 'New length cannot be zero or undefined',
        title: 'Verify your data'
      });
      return;
    }

    if (this.newLength > this.fullLength) {
      this._dialogService.openAlert({
        message: 'New Length cannot be more than available length',
        title: 'Incorrect values entered'
      });
      return;
    }

    if (this.newPieceNumber == null || this.newPieceNumber == '') {
      this._dialogService.openAlert({
        message: 'New Piece number cannot be empty',
        title: 'Incorrect values entered'
      });
      return;
    }

    this._inventoryService.cutPiece(this.pieceNumber, this.newPieceNumber, this.fullLength - this.newLength, this.newLength).subscribe(
      response => {
        if (response.status == 'SUCCESS') {
          this._dialogService.openConfirm({
            message: 'Item has been cut! Do you want to print new labels for both pieces?',
            title: 'Success'
          }).afterClosed().subscribe(
            r => {
              if (r) {
                // Wants to print. Print both labels
                [this.pieceNumber, this.newPieceNumber].forEach(
                  (piece_no: string) => {
                    this._inventoryService.getPieceByPieceNumber(piece_no).subscribe(
                      response => {
                        this.printRollLabel(response.id);
                      }
                    );
                  });
              }

              this.goBack()
            }
          );
          // ^ If it worked go back to the main screen
        } else {
          if (response.error.startsWith('Duplicate entry')) {
            this._dialogService.openAlert({
              message: 'The selected piece number already exists. Please use a different one',
              title: 'Error'
            });

          } else {
            this._dialogService.openAlert({
              message: 'Could not save new lengths!',
              title: 'Error'
            });
          }
        }
      },
      error => {
        this._dialogService.openAlert({
          message: 'Database error: ' + error,
          title: 'Error'
        });
      }
    );
  }

  printRollLabel(piece_id: number) {
    this._inventoryService.getPiece(piece_id, false).subscribe(
      (response: Piece[]) => {
        if (Array.isArray(response) && response.length > 0) {
          let piece = response[0];

          // Fill in the gaps from the product view
          this._productService.getOneProduct(piece.color_id + '').subscribe(
            (product: Product) => {
              if (product != null) {
                this._printingService.print(
                  {
                    company_name: piece.branch_name,
                    collection: piece.collection_name,
                    design: piece.design_name,
                    part_number: piece.piece_number,
                    color: piece.color_name,
                    grade_cut: piece.grade_code,
                    lot_no: piece.lot_number,

                    unit_type: product.unit_type,

                    meters: product.unit_type === 'LENGTH' ? piece.length : 0,
                    yards: product.unit_type === 'LENGTH' ? (piece.length * 1.09361).toFixed(2) : 0,
                    meters_sq: product.unit_type === 'AREA' ? piece.length : 0,
                    sq_feet: product.unit_type === 'AREA' ? (piece.length * 10.7639).toFixed(2) : 0,

                    kilos: piece.weight,
                    composition: product.composition,
                    width: product.width,
                    weight: product.weight_gsm

                  }, this._authService.getPrinterId(), 1, 'roll').subscribe(
                    response => {
                      if (response['status'] == 'SUCCESS') {
                        this._dialogService.openAlert({
                          message: 'Sent to print queue!',
                          title: 'Success'
                        });
                      } else {
                        this._dialogService.openAlert({
                          message: 'Could not send to print queue!',
                          title: 'Failed'
                        });
                      }
                    }
                  );
              } else {
                this._dialogService.openAlert({
                  message: 'The product information could not be retrieved!',
                  title: 'Failed'
                });
              }
            }
          );
        } else {
          this._dialogService.openAlert({
            message: 'The roll information could not be found!',
            title: 'Failed'
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/inventory/cut-item/cut-item.component.ts